module.exports = __webpack_public_path__ + "img/ro_get.e233316.png";